// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MForm-components-MfTabsView-MfTabsView-module__vertFit--zGqhH {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-components-MForm-components-MfTabsView-MfTabsView-module__vertFit--zGqhH .src-components-MForm-components-MfTabsView-MfTabsView-module__content--x5Xam {
  flex: 1;
  overflow: auto;
}
.src-components-MForm-components-MfTabsView-MfTabsView-module__tabs--ML_m7 {
  padding: 0 16px;
}
.src-components-MForm-components-MfTabsView-MfTabsView-module__tabs--ML_m7 .ant-tabs-nav {
  margin-bottom: 8px;
}
/*# sourceMappingURL=MfTabsView.module.css.map */`, "",{"version":3,"sources":["webpack://./MfTabsView.module.less","webpack://./src/components/MForm/components/MfTabsView/MfTabsView.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EAEA,aAAA;EACA,sBAAA;ACAF;ADLA;EAQI,OAAA;EACA,cAAA;ACAJ;ADIA;EACE,eAAA;ACFF;ADCA;EAII,kBAAA;ACFJ;AACA,gDAAgD","sourcesContent":[".vertFit {\n  height: 100%;\n  overflow: hidden;\n\n  display: flex;\n  flex-direction: column;\n\n  .content {\n    flex: 1;\n    overflow: auto;\n  }\n}\n\n.tabs {\n  padding: 0 16px;\n\n  :global(.ant-tabs-nav) {\n    margin-bottom: 8px;\n  }\n}\n",".vertFit {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.vertFit .content {\n  flex: 1;\n  overflow: auto;\n}\n.tabs {\n  padding: 0 16px;\n}\n.tabs :global(.ant-tabs-nav) {\n  margin-bottom: 8px;\n}\n/*# sourceMappingURL=MfTabsView.module.css.map */"],"sourceRoot":""}]);
// Exports
export var vertFit = `src-components-MForm-components-MfTabsView-MfTabsView-module__vertFit--zGqhH`;
export var content = `src-components-MForm-components-MfTabsView-MfTabsView-module__content--x5Xam`;
export var tabs = `src-components-MForm-components-MfTabsView-MfTabsView-module__tabs--ML_m7`;
export default ___CSS_LOADER_EXPORT___;
